module.exports = __webpack_public_path__ + "static/media/businessUnit.b710be09.svg";